module.exports = __webpack_public_path__ + "img/lianlu.bfcf0c12.png";